module.exports = __webpack_public_path__ + "static/media/_MIC2617.thumbnail.78f26498.png";